

import { createStore, combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { persistStore, persistReducer } from 'redux-persist';
import userReducer from './userReducer';
import urlReducer from './urlReducer';
import screenReducer from './screenReducer';




// Define the persist configuration
const persistConfig = {
    key: 'root',
    storage,
};

const rootReducer = combineReducers({
    userdetails: userReducer,
    url: urlReducer,
    screen: screenReducer,
});


// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);


const store = createStore(persistedReducer);

// Create a persistor
export const persistor = persistStore(store);

export default store;